import { cn } from "./utils";
import React from "react";

const DotLabel = ({
  className,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      "wbuc-flex wbuc-items-center wbuc-gap-[0.375rem] wbuc-text-base wbuc-font-medium wbuc-leading-4 before:wbuc-h-2 before:wbuc-w-2 before:wbuc-rounded-[0.125rem] before:wbuc-bg-[#3b65ee] before:wbuc-content-['']",
      className
    )}
    {...rest}
  />
);

export default DotLabel;
